import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { SITE_KOREANAIR_SAVINGS } from '@ecp/common/src/const/site/siteNumberConst.js';

import { navigationOffsetState } from '@mo-recoil/common/navigation/atom';
import { showFooterState } from '@mo-recoil/common/footer/atom';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import ContactInfo from './ContactInfo';
import CompanyInfo from './CompanyInfo';
import KoreanAirSavingsFooterNotice from '@ecp/mo/sites/koreanairSavings/components/footer/KoreanAirSavingsFooterNotice';

const PageFooter = () => {
  const showFooter = useRecoilValue(showFooterState);
  const navigationOffset = useRecoilValue(navigationOffsetState);

  const { siteNumber } = useSiteInfo();
  const isKoreanair = siteNumber === SITE_KOREANAIR_SAVINGS && false;
  return (
    <>
      {showFooter && (
        <Container>
          {isKoreanair && (
            <>
              <KoreanAirSavingsFooterNotice />
              <Spacing top={20} />
            </>
          )}
          <ContactInfo />
          <CompanyInfo />
          <Spacing top={navigationOffset} />
        </Container>
      )}
    </>
  );
};

export default PageFooter;

const Container = styled(FlexBoxColumn)`
  width: 360px;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.color.background.white};
`;
